import { useDisclosure } from '@chakra-ui/react'

export default useDisclosure
